"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._exportAdjustmentStockpile = exports._modifyStockpileTicket = exports._getDataSummaryStockpile = exports._getGridUploadHistory = exports._uploadProcessSurvey = exports._uploadProcessManual = exports._uploadDocumentStockpile = exports._deleteAdjustmentStockpile = exports._downloadTemplateStockpile = exports._getGridDeletedList = exports._getGridAdjustmentStockpile = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const _getGridAdjustmentStockpile = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const filterFilter = arg.filter
            ? {
                logic: arg.filter.logic,
                filters: arg.filter.filters
                    .map((item) => item.field === 'is_duplicated' ? null : item)
                    .filter((item) => item !== null)
            }
            : { logic: 'and', filters: [] };
        const filterString = filterFilter.filters.length > 0 ? JSON.stringify(filterFilter) : undefined;
        const sortString = arg.sort ? arg.sort.length > 0 ? JSON.stringify(arg.sort) : undefined : undefined;
        const url = String(process.env.API_ENDPOINT) + '/adjustment/stockpile';
        const params = {
            skip: arg.skip,
            take: arg.take,
            sort: sortString,
            filter: filterString,
            end_date: arg.end_date,
            start_date: arg.start_date,
        };
        const is_duplicated = (_a = arg.filter) === null || _a === void 0 ? void 0 : _a.filters.find((item) => item.field === 'is_duplicated');
        if (is_duplicated) {
            params.is_duplicated = is_duplicated.value === 'Duplicated' ? 'true' : 'false';
        }
        const config = {
            params: params,
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridAdjustmentStockpile = _getGridAdjustmentStockpile;
const _getGridDeletedList = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/deleted-stockpile';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridDeletedList = _getGridDeletedList;
const _downloadTemplateStockpile = (type) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/template';
    const config = {
        params: { type: type },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, url: '' };
    }
});
exports._downloadTemplateStockpile = _downloadTemplateStockpile;
const _deleteAdjustmentStockpile = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/delete-stockpile';
        const response = yield axios_1.default.post(url, arg, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return response.data;
    }
    catch (e) {
        return (0, error_response_1.errorResponse)(e);
    }
});
exports._deleteAdjustmentStockpile = _deleteAdjustmentStockpile;
const _uploadDocumentStockpile = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/upload-file';
    try {
        const response = yield axios_1.default.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        });
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, name: '', countData: 0 };
    }
});
exports._uploadDocumentStockpile = _uploadDocumentStockpile;
const _uploadProcessManual = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/process-upload';
        const data = { type: 'mt', filename: payload.filename };
        const response = yield axios_1.default.post(url, data, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        });
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, message: '', countData: 0 };
    }
});
exports._uploadProcessManual = _uploadProcessManual;
const _uploadProcessSurvey = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/process-upload';
        const data = {
            type: 'sc',
            filename: payload.filename,
            justification: payload.justification,
            filename_approval: payload.filename_approval
        };
        const response = yield axios_1.default.post(url, data, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        });
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, message: '', countData: 0 };
    }
});
exports._uploadProcessSurvey = _uploadProcessSurvey;
const _getGridUploadHistory = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/stockpile/upload-log';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridUploadHistory = _getGridUploadHistory;
const _getDataSummaryStockpile = ({ start_date, end_date }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/stockpile/card';
        const config = {
            params: {
                start_date: start_date,
                end_date: end_date ? end_date : start_date
            },
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            dataTon: [],
            dataTrip: [],
            errorMessage,
        };
    }
});
exports._getDataSummaryStockpile = _getDataSummaryStockpile;
const _modifyStockpileTicket = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/stockpile/modify';
        const response = yield axios_1.default.post(url, data, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return response.data;
    }
    catch (e) {
        return (0, error_response_1.errorResponse)(e);
    }
});
exports._modifyStockpileTicket = _modifyStockpileTicket;
const _exportAdjustmentStockpile = ({ sort, filter, start_date, end_date }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const filterFilter = filter
            ? {
                logic: filter.logic,
                filters: filter.filters
                    .map((item) => item.field === 'is_duplicated' ? null : item)
                    .filter((item) => item !== null)
            }
            : { logic: 'and', filters: [] };
        const url = String(process.env.API_ENDPOINT) + '/adjustment/stockpile/export';
        const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
        const filterString = filterFilter.filters.length > 0 ? JSON.stringify(filterFilter) : undefined;
        const params = {
            sort: sortString,
            end_date: end_date,
            filter: filterString,
            start_date: start_date,
        };
        const is_duplicated = filter === null || filter === void 0 ? void 0 : filter.filters.find((item) => item.field === 'is_duplicated');
        if (is_duplicated) {
            params.is_duplicated = is_duplicated.value === 'Duplicated' ? 'true' : 'false';
        }
        const config = {
            params: params,
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, content: '', name: '', data: {} };
    }
});
exports._exportAdjustmentStockpile = _exportAdjustmentStockpile;
